import { render, staticRenderFns } from "./myCardTitle.vue?vue&type=template&id=0088cc9c&scoped=true"
import script from "./myCardTitle.vue?vue&type=script&lang=js"
export * from "./myCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0088cc9c",
  null
  
)

export default component.exports